import Vue from 'vue'
import Enum from './mutation-enum.js'

export default {
    SetShow: ({ commit }, show) => {
        commit(Enum.SET_SHOW, show);
    }
}


// WEBPACK FOOTER //
// ./src/_store/modules/tabBar/actions.js